import React from "react";

import { isPortrait } from "@/modules/commonMobile";
import { INiuNiuHistoryType } from "@/types/GameHistoryTypes";

interface IProps {
	pcode: string;
	type: string;

	history: INiuNiuHistoryType[];
	
	mobile?: boolean;
	expanded?: boolean;
	small?: boolean;
}

import "./index.scss";

//Nonstandard large roadmap
export default class M24 extends React.Component<IProps> {
	totalColumns: number;

	render() {
		switch (this.props.type) {
			case "top-right":
				this.totalColumns = 5;
			break;
			case "bottom":
				this.totalColumns = 
					this.props.mobile ? (
						isPortrait() ? 5 :
						this.props.expanded ? 10 : 2
					) :
					// Lobby desktop & multi table
					this.props.small ? 5 :
					10;
			break;
			default:
				this.totalColumns = 1;
			break;
		}
		
		// const emptyHistoryItem = {"dealer":"5c-3h-6c-6d-6s","player1":"Qh-Kd-Qc-Js-Qd","player2":"Th-3c-8c-Qs-7c","player3":"Tc-8d-2d-3s-Jd","result":"player1,player2,player3","valuedealer":"nobul","valueplayer1":"gong","valueplayer2":"bull8","valueplayer3":"bull3"};
		const emptyHistoryItem: INiuNiuHistoryType = {
			periode: 0,
			dealer: "",
			player1: "",
			player2: "",
			player3: "",
			result: null,
			valuedealer: "",
			valueplayer1: "",
			valueplayer2: "",
			valueplayer3: ""
		};
		const history = this.props.history.slice(0).reverse() || [];
		//Adds 1 empty history item for viewing
		history.push(emptyHistoryItem);
		
		//Todo: use translations
		// const playerNames = [this.props.langdata["txt_banker"], this.props.langdata["txt_player"]];
		const playerNames = [
			"Banker",
			"Player 1",
			"Player 2",
			"Player 3"
		];
		const shortPlayerNames = ["Banker", "P1", "P2", "P3"];

		return this.props.type === "bottom" ?
			<div className="m24-history">
				<div className="name-container">
				{
					(this.props.mobile && !this.props.expanded ?
						shortPlayerNames : playerNames).map((item, idx) => (
						<div key={`pname${idx}`} className="name">
						{ item }
						</div>
					))
				}
				</div>

				<div id="scrollable_m24_roadmap"
					 className="number-container">
				{
					["dealer", "player1", "player2", "player3"].map((rowItem, idx) => (
							<div key={`smr_${idx}`} className="row">
								{
									// roadmapColumns
									history.slice(-this.totalColumns).map((cellItem, _idx) => {
										const isNullOrEmpty = cellItem.result === null;
										
										const wins = !isNullOrEmpty ? cellItem.result.split(",") : [];
										const text = cellItem["value" + rowItem];
										const lastChar = text[text.length - 1];
										
										return (
											<div key={`smr_hist_${_idx}`} className="number">
												<div className={lastChar === "0" ? "blue" : ""}>
													{
														//emptyHistoryItem
														isNullOrEmpty ? "" :
														isNaN(lastChar) ? "NB" :
														lastChar === "0" ? "BB" :
														lastChar
													}
												</div>
												
												{
													wins.indexOf(rowItem) >= 0 ?
													<div className="win">
													{ this.props.small ? "." : "WIN" }
													</div> : null
												}
											</div>
										);
									})
								}
							</div>
						)
					)
				}
				</div>
			</div>
			: null;
	}
}